import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const C = {
  primary: "#1A1A2E",
  accent: "#C9A84C",
  accentLight: "#FDF6E3",
  accentBorder: "rgba(201,168,76,0.25)",
  border: "#e5e7eb",
  textMuted: "#6b7280",
};

export default function MPBody() {
  const history = useHistory();
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categories = [
    {
      name: "haircut",
      label: t("Haircut") || "Haircut",
      image:
        "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=400&h=300&fit=crop",
    },
    {
      name: "nails",
      label: t("Nails") || "Nails",
      image:
        "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400&h=300&fit=crop",
    },
    {
      name: "lashes",
      label: t("Lashes") || "Lashes",
      image:
        "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=400&h=300&fit=crop",
    },
  ];

  const isDesktop = windowWidth > 768;

  return (
    <div
      style={{
        width: "100%",
        padding: "48px 20px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Section header */}
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            backgroundColor: C.accentLight,
            border: `1px solid ${C.accentBorder}`,
            borderRadius: "50px",
            padding: "6px 16px",
            marginBottom: "14px",
          }}
        >
          <span style={{ fontSize: "14px" }}>✂️</span>
          <span style={{ fontSize: "13px", fontWeight: "600", color: C.accent }}>
            {t("BrowseCategories") || "Browse Categories"}
          </span>
        </div>
        <h2
          style={{
            fontSize: isDesktop ? "30px" : "22px",
            fontWeight: "800",
            color: C.primary,
            margin: 0,
            letterSpacing: "-0.3px",
          }}
        >
          {t("WhatAreYouLookingFor") || "What are you looking for?"}
        </h2>
      </div>

      {/* Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isDesktop ? "repeat(3, 1fr)" : "1fr",
          gap: "24px",
          maxWidth: "1100px",
          width: "100%",
        }}
      >
        {categories.map((category) => (
          <div
            key={category.name}
            onClick={() => history.push(`/allcategories/${category.name}`)}
            style={{
              borderRadius: "16px",
              overflow: "hidden",
              cursor: "pointer",
              boxShadow: "0 2px 10px rgba(26,26,46,0.08)",
              transition: "all 0.3s ease",
              border: `1px solid ${C.border}`,
              backgroundColor: "#fff",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow = `0 12px 28px rgba(26,26,46,0.16)`;
              e.currentTarget.style.borderColor = C.accent;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 10px rgba(26,26,46,0.08)";
              e.currentTarget.style.borderColor = C.border;
            }}
          >
            <div style={{ position: "relative", overflow: "hidden" }}>
              <img
                src={category.image}
                alt={category.name}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  display: "block",
                  transition: "transform 0.4s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
              {/* Overlay gradient at bottom */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "60px",
                  background: "linear-gradient(transparent, rgba(26,26,46,0.4))",
                  pointerEvents: "none",
                }}
              />
            </div>
            <div
              style={{
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#fff",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: "700",
                  color: C.primary,
                  textTransform: "capitalize",
                }}
              >
                {category.label}
              </h3>
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: C.accentLight,
                  border: `1px solid ${C.accentBorder}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: C.accent,
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                →
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
